<template>
  <div>
    <component
      :is="componentName"
      v-for="data in arrData"
      :key="data.k"
      :data="data"
      :is-me="isMe"
      :options="componentsOptions"
      @delete="deleteElm"
      @save-changes="saveChanges"
    />
    <div v-if="isMe && canAdd && $store.state.edit.on">
      <a href="#" class="btn btn-default btn-sm waves-effect" @click="addNew">
        {{ $t(addButtonText) }}
      </a>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import enums from '@/utils/enum'
import { SET_EDIT_SAVING_STATE } from '@/state/action-types'
import { SET_EDIT_UNSAVED } from '@/state/mutation-types'
import { NetworkError } from '@/utils/notification'

export default {
  name: 'ComponentLister',
  props: {
    isMe: {
      type: Boolean,
      required: true,
    },
    componentName: {
      type: String,
      required: true,
    },
    componentsData: {
      type: Array,
      required: true,
    },
    componentsOptions: {
      type: Object,
      default: () => ({}),
    },
    canAdd: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: true,
    },
    addButtonText: {
      type: String,
      default: 'Add',
    },
    fieldName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      arrData: [],
    }
  },
  mounted() {
    this.arrData = this.componentsData
    if (this.arrData.length > 0 && !this.arrData[0].hasOwnProperty('k')) {
      // We create new keys
      this.arrData.forEach((elem, i) => {
        // eslint-disable-next-line no-param-reassign -- Baseline eslint ignore please fix if working on this
        elem.k = (+new Date()).toString(36) + i
      })
    }
  },
  methods: {
    addNew() {
      this.arrData.push({ k: (+new Date()).toString(36) })
    },
    saveChanges() {
      if (this.componentName === 'EditLinks') {
        this.saveLinks()
      }
    },
    deleteElm(key) {
      this.arrData = this.arrData.filter((elm) => elm.k !== key)
      this.saveLinks()
    },
    async saveLinks() {
      this.$store.dispatch(SET_EDIT_SAVING_STATE, true)
      const jsonLinks = this.arrData.length
        ? this.arrData.map((a) => ({
            url: a.url.startsWith('www.') ? `http://${a.url}` : a.url,
            title: a.title,
          }))
        : []
      this.$store.commit(SET_EDIT_UNSAVED, true)
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation update($profileData: UpdateProfileInput!) {
              updateProfile(input: $profileData) {
                publicKey
                links {
                  url
                  title
                }
              }
            }
          `,
          variables: {
            profileData: {
              localId: this.account.profile.id,
              links: jsonLinks,
            },
          },
        })
        this.$store.dispatch(SET_EDIT_SAVING_STATE, false)
        this.$store.commit(SET_EDIT_UNSAVED, false)
      } catch (e) {
        this.$store.commit(SET_EDIT_UNSAVED, true)
        this.$store.dispatch(SET_EDIT_SAVING_STATE, false)
        new NetworkError({
          severity: enums.notification.severity.CRITICAL,
          ex: e,
        }).dispatch(this)

        throw e
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
